const React = require('react')
const PropTypes = require('prop-types')
const _ = require('lib/underscore')

const MetaSection = require('./meta_section')

const map = {
    'jobs': {
        label: 'Work',
        item_key: 'job',
        slice: [0, 1], // only show 1 job
    },
    'schools': {
        label: 'Education',
        item_key: 'school',
        slice: [0, 5], // only show up to 5 schools
    },
}

function Meta(props) {

    const { user } = props

    const sections = []

    Object.keys(map).forEach((type) => {
        const section = user[type]
        if (section && section.length) {
            // apply slice parameters from map
            const slice = section.slice.apply(section, map[type].slice)
            sections.push({
                type,
                label: map[type].label,
                items: _.pluck(slice, map[type].item_key),
            })
        }
    })

    if (! sections.length) return null

    return (
        <section className="meta inset">
            <ul className="meta-sections">
                {sections.map((section, i) => <MetaSection key={i} {...section} />)}
            </ul>
        </section>
    )

}

Meta.propTypes = {
    user: PropTypes.shape({
        jobs: PropTypes.arrayOf(PropTypes.object),
        schools: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
}

module.exports = Meta
